import React, { useState, useEffect } from 'react'
import { I18n } from 'react-redux-i18n'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import { Container, Button, Col, Row, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { MARKETING } from '../../../constants'

const ModalCopyTemplate = ({ isOpenModal, setFormCreate, setIsOpenModal, textToCopy }) => {
  const [codeCopied, setCodeCopied] = useState(false)

  useEffect(() => {
    if (isOpenModal) {
      setCodeCopied(false)
    }
  }, [isOpenModal])

  const onCloseCopyTemplateModal = () => {
    setFormCreate && setFormCreate({ isOpen: false })
    setIsOpenModal(false)
  }

  return (
    <Modal id='modalCopy' isOpen={isOpenModal} centered={true} toggle={() => setIsOpenModal(!isOpenModal)} className='modal-copy' size={'lg'}>
      <ModalHeader>{I18n.t('dashboard_template-code')}</ModalHeader>
      <ModalBody>
        <Row>
          <legend>
            {`${I18n.t('templates_copy_legend')}.`}
          </legend>
        </Row>
        <Row className={'seccionWrapper-1'}>
          <Col sm={1}>
            <div className={'numbers'}>1</div>
          </Col>
          <Col className={'seccion-1'}>
            <h3>{I18n.t('templates_copy_title2')}</h3>
            <div className='new-input disabled-textarea' dangerouslySetInnerHTML={{ __html: textToCopy }}/>
            <CopyToClipboard
              style={{ cursor: 'pointer' }}
              text={textToCopy}
              onCopy={() => setCodeCopied(true)}
            >
              <Button color='primary' size='sm'>
                {I18n.t(codeCopied ? 'templates_copied_code' : 'templates_copy_code')}
              </Button>
            </CopyToClipboard>
          </Col>
        </Row>
        <Row className={'seccionWrapper-2'}>
          <Col sm={1}>
            <div className={'numbers'}>2</div>
          </Col>
          <Col>
            <h3>{I18n.t('templates_copy_title3')}</h3>
            <p>
              {`${I18n.t('templates_copy_detail1')} `}
              <a href={MARKETING.urlsTwillo.submit} target='blank'>
                {`${I18n.t('templates_copy_detail2')}`}
              </a>
              {` ${I18n.t('templates_copy_detail3')}.`}
            </p>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Container>
          <Row noGutters>
            <Col className='text-left'>
              <Button color='secondary' size={'sm'} onClick={onCloseCopyTemplateModal}>
                {I18n.t('dashboard_close')}
              </Button>
            </Col>
          </Row>
        </Container>
      </ModalFooter>
    </Modal>
  )
}

export default ModalCopyTemplate
